export function Header() {
    return (
        <header className="header">
            <h1>Relume Components</h1>
            <p>Browse and copy component JSON data</p>
        </header>
    );
}
